import { DataGrid } from "@mui/x-data-grid";
import { operatorResponseColumns } from "../../datatablesource";
import { useEffect, useState } from "react";

import fetchURLForm from "../../../../functions/fetchURLForm";
import { fetchUrl } from "../../../../functions/fetchUrl";

import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Box from "@mui/material/Box";

const OperatorResponseMonthly = ({ table }) => {
  console.log(table)
  useState("Loading...");
  const today = new Date();

  const [data, setData] = useState([]);
  const [valueDateFrom, setValueDateFrom] = useState(today);
  const [valueDateTo, setValueDateTo] = useState(today);

  const [requestText, setRequestText] = useState("");

  const handleChange = (event) => {
    setRequestText(event.target.value);
  };

  useEffect(() => {
    setData([]);
    //     "valueDateTo": "01-20-2023"

    const monthFromNumber = (valueDateFrom.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const dayFromNumber = valueDateFrom.getDate().toString().padStart(2, "0");
    const yearFromNumber = valueDateFrom.getFullYear();

    const monthToNumber = (valueDateTo.getMonth() + 1)
      .toString()
      .padStart(2, "0");
    const dayToNumber = valueDateTo.getDate().toString().padStart(2, "0");
    const yearToNumber = valueDateTo.getFullYear();

    const dateFrom =
      monthFromNumber + "-" + dayFromNumber + "-" + yearFromNumber;

    const dateTo = monthToNumber + "-" + dayToNumber + "-" + yearToNumber;

    const bodySend = {
      valueDate: dateFrom,
      valueToDate: dateTo,
      requestText,
    };

    const fetchData = async () => {
      const response = await fetchUrl({
        method: "POST",
        apiName: table,
        reqBody: bodySend
      });
      if (response.success) {
        setData(response.result);
      }
    };
    fetchData();
  }, [table, valueDateFrom, valueDateTo, requestText]);

  return (
    <>

      <Box
        component="form"
        sx={{
          "& > :not(style)": { m: 1, width: "40ch" },
        }}
        noValidate
        autoComplete="on"
      >
        <TextField
          id="outlined-requestText"
          label="Search Response ..."
          value={requestText}
          onChange={handleChange}
          inputProps={{
            style: {
              height: "50px",
            },
          }}
        />
      </Box>
      <div style={{ display: "flex", margin: "10px 10px" }}>
        <div style={{ display: "inline-block", margin: "0 10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From:"
              value={valueDateFrom}
              onChange={(newValue) => {
                setValueDateFrom(new Date(newValue));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
        <div style={{ display: "inline-block", margin: "0 10px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To:"
              value={valueDateTo}
              onChange={(newValue) => {
                setValueDateTo(new Date(newValue));
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
      </div>
      <div>
        <DataGrid
          className="ml-1"
          rows={data}
          columns={operatorResponseColumns}
          pageSize={15}
          rowsPerPageOptions={[5]}
          style={{ height: "60vh" }}
          getRowId={(data) => data.id}
        />
      </div>

    </>
  );
};

export default OperatorResponseMonthly;
